import { API_BASE_URL, apiGet } from '@/api/http';

import type { Education } from '@/types/reference';

export const getEducationList = () =>
  apiGet<Education[]>(`${API_BASE_URL}education/`);
